<template>
  <div>
    <accettazione-ssn-impegnativa-modal-component
      ref="cmpAccettazioneImpegnativa"
      :isDematerializzata="false"
      :isFirstDematerializzata="false"
      :codiceFiscalePaziente="jsonData.accettazione.accettazioneAnagrafica.identificativo"
      @onAggiungiImpegnativa="onAggiungiImpegnativa"
      @onChangeTipologiaRicetta="onChangeTipologiaRicetta"
    />
    <b-card
      class="sa-card sa-card-border"
      header-tag="header"
      footer-tag="footer"
      title=""
    >
      <template #header>
        <div
          class="d-flex justify-content-between align-items-center custom-header"
        >
          <span>Impegnativa e dettaglio prestazioni</span>
          <b-button
            size="sm"
            variant="success"
            @click="onOpenModalImpegnativa()"
            :disabled="!isEdit"
            >Aggiungi</b-button
          >
        </div>
      </template>
      <b-row
        class="sa-padding-left text-left"
        style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem"
      >
        <b-col cols="12">

          <div class="b-table-sticky-header">
            <b-table
              sticky-header
              ref="table"
              stacked="lg"
              striped
              hover
              :items="localData.ricette"
              :fields="headersImpegnative"
              :current-page="1"
              :per-page="100"
              sort-icon-left
              head-variant="light"
              class="sa-b-table"
              empty-text="no data"
            >
              <template v-slot:cell(tipologia)="row">
                <span style="font-weight: 700; margin-right: 3px">{{
                  row.item.tipologia
                }}</span>
              </template>
              <template v-slot:cell(nre)="row">
                <span style="font-weight: 700; margin-right: 3px">{{
                  row.item.codiceBar1 
                }}{{ row.item.codiceBar2 }}</span>
              </template>
              <template v-slot:cell(prestazioni)="row">
                <span style="font-weight: 700; margin-right: 3px">
                  {{ row.item.prestazioni ? row.item.prestazioni.length : 0 }}
                </span>
              </template>
              <template #row-details>
                <b-row>
                  <b-col cols="12">
                    <b-table
                      sticky-header
                      ref="table1"
                      stacked="lg"
                      striped
                      hover
                      :items="itemsDetail"
                      :fields="headersPrestazioni"
                      :current-page="1"
                      :per-page="100"
                      sort-icon-left
                      head-variant="light"
                      class="sa-b-table"
                    >
                      <template v-slot:cell(quantita)="row">
                        <div v-if="row.item.new">
                          <b-form-input
                            v-model="prestazione.quantita"
                            type="number"
                          ></b-form-input>
                        </div>
                        <div v-else>
                          <b-form-input
                            v-if="!isRowEdit(row)"
                            v-model="selectedRowEditItem.quantita"
                            type="number"
                          ></b-form-input>
                          <span v-else>{{ row.item.quantita }}</span>
                        </div>
                      </template>

                      <template v-slot:cell(listino)="row">
                        <div v-if="row.item.new">
                          <b-form-select
                            v-model="prestazione.idListino"
                            :options="listinoOptions"
                            value-field="value"
                            text-field="text"
                          >
                            <template #first>
                              <b-form-select-option disabled :value="null"
                                >Seleziona</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                        <div v-else>
                          <b-form-select
                            v-model="selectedRowEditItem.idListino"
                            :options="listinoOptions"
                            value-field="value"
                            text-field="text"
                            v-if="!isRowEdit(row)"
                          >
                            <template #first>
                              <b-form-select-option disabled :value="null"
                                >Seleziona</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                          <span v-else>
                            {{ getListinoText(row.item.idListino) }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:cell(descrizionePrestazione)="row">
                        <div v-if="row.item.new">
                          <b-form-select
                            v-model="prestazione.descrizionePrestazione"
                            :options="prestazioniOptions"
                            value-field="value"
                            text-field="text"
                            @change="onChangePrestazione"
                          >
                            <template #first>
                              <b-form-select-option disabled :value="null"
                                >Seleziona</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                        </div>
                        <div v-else>
                          <b-form-select
                            v-model="selectedRowEditItem.descrizionePrestazione"
                            :options="prestazioniOptions"
                            value-field="value"
                            text-field="text"
                            v-if="!isRowEdit(row)"
                          >
                            <template #first>
                              <b-form-select-option disabled :value="null"
                                >Seleziona</b-form-select-option
                              >
                            </template>
                          </b-form-select>
                          <span v-else>
                            {{ row.item.descrizionePrestazione }}
                          </span>
                        </div>
                      </template>
                      <template v-slot:cell(prezzo)="row">
                        <div v-if="row.item.new">
                          <b-form-input
                            v-model="prestazione.prezzo"
                            type="text"
                            :disabled="true"
                          ></b-form-input>
                        </div>
                        <div v-else>
                          <b-form-input
                            v-model="selectedRowEditItem.prezzo"
                            type="text"
                            :disabled="true"
                            v-if="!isRowEdit(row)"
                          ></b-form-input>
                          <span v-else>{{ row.item.prezzo }}€</span>
                        </div>
                      </template>
                      <!-- <template v-slot:cell(importo)="row">
                        <div v-if="row.item.new">
                          <b-form-input
                            v-model="prestazione.importo"
                            type="number"
                            :disabled="true"
                          ></b-form-input>
                        </div>
                        <div v-else>
                          <b-form-input
                            v-model="selectedRowEditItem.importo"
                            type="number"
                            :disabled="true"
                            v-if="!isRowEdit(row)"
                          ></b-form-input>
                          <span v-else>{{ row.item.importo }}€</span>
                        </div>
                      </template> -->
                      <template v-slot:cell(dataErogazione)="row">
                        <div v-if="row.item.new">
                          <date-picker
                            format="DD/MM/YYYY"
                            value-type="timestamp"
                            v-model="prestazione.dataErogazione"
                            type="date"
                          ></date-picker>
                        </div>
                        <span v-else>
                          <date-picker
                            format="DD/MM/YYYY"
                            value-type="timestamp"
                            v-model="selectedRowEditItem.dataErogazione"
                            type="date"
                            v-if="!isRowEdit(row)"
                          ></date-picker>
                          <span v-else>
                            {{ formatDate(row.item.dataErogazione) }}
                          </span>
                        </span>
                      </template>
                      <template v-slot:cell(actions)="row">
                        <div
                          v-if="row.item.new && selectedRowEditIndex == null"
                        >
                          <b-container class="bv-example-row">
                            <b-button
                              :disabled="isBtnAggiungiPrestazioneDisabled() || !isEdit"
                              size="sm"
                              v-b-tooltip.hover
                              title="Aggiungi Prestazione"
                              variant="outline-success"
                              @click="onAggiungiPrestazione(row)"
                            >
                              <font-awesome-icon icon="plus" />
                            </b-button>
                          </b-container>
                        </div>
                        <div v-else>
                          <b-container class="bv-example-row">
                            <div v-if="!isRowEdit(row)">
                              <b-button
                                size="sm"
                                v-b-tooltip.hover
                                title="Conferma Modifica"
                                variant="outline-info"
                                @click="onConfermaModificaPrestazione(row)"
                              >
                                <font-awesome-icon icon="check" />
                              </b-button>
                              <b-button
                                size="sm"
                                v-b-tooltip.hover
                                title="Annulla Modifica"
                                variant="outline-danger"
                                @click="onAnnullaModifica(row)"
                              >
                                <font-awesome-icon icon="times" />
                              </b-button>
                            </div>
                            <b-button
                              size="sm"
                              v-if="
                                selectedRowEditIndex == null && isRowEdit(row)
                              "
                              :disabled="!isEdit"
                              v-b-tooltip.hover
                              title="Modifica Prestazione"
                              variant="outline-info"
                              @click="onModificaPrestazione(row)"
                            >
                              <font-awesome-icon icon="edit" />
                            </b-button>
                            <b-button
                              v-if="selectedRowEditIndex == null"
                              size="sm"
                              :disabled="!isEdit"
                              v-b-tooltip.hover
                              title="Rimuovi Prestazione"
                              variant="outline-danger"
                              @click="onEliminaPrestazione(row)"
                            >
                              <font-awesome-icon icon="trash" />
                            </b-button>
                          </b-container>
                        </div>
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
              </template>
              <template v-slot:cell(actions)="row">
                <b-container class="bv-example-row">
                  
                  <b-button
                    size="sm"
                    v-b-tooltip.hover
                    title="Prestazioni"
                    variant="outline-primary"
                    @click="onClickStorico(row)"
                  >
                    <font-awesome-icon
                      :icon="
                        row.item._showDetails ? 'arrow-down' : 'arrow-left'
                      "
                    />
                  </b-button>
                </b-container>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnImpegnativaModalComponent from "./AccettazioneSsnImpegnativaModalComponent.vue";
export default {
  components: { DatePicker, AccettazioneSsnImpegnativaModalComponent },
  mixins: [UtilityMixin],
  props: {
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isDematerializzata: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    jsonData: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
     ricette: {
      type: Array,
      required: true,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      listinoOptions: [
        { text: "LISTINO REGIONALE SSN", value: "LISTINOREGIONALESSN" },
      ],
      prestazioniOptions: [
        {
          text: "PRESTAZIONE1",
          value: "PRESTAZIONE1",
          codice: "A001.01",
          listino: "LISTINO REGIONALE SSN",
          prezzo: 12.5
        },
        {
          text: "PRESTAZIONE2",
          value: "PRESTAZIONE2",
          codice: "A001.02",
          listino: "LISTINO REGIONALE SSN",
          prezzo: 15.0,
        },
        {
          text: "PRESTAZIONE3",
          value: "PRESTAZIONE3",
          codice: "A001.03",
          listino: "LISTINO REGIONALE SSN",
          prezzo: 2.0,
        },
        {
          text: "PRESTAZIONE4",
          value: "PRESTAZIONE4",
          codice: "A001.04",
          listino: "LISTINO REGIONALE SSN",
          prezzo: 52.0,
        },
                {
          text: "PRESTAZIONE5",
          value: "PRESTAZIONE5",
          codice: "A001.05",
          listino: "LISTINO REGIONALE SSN",
          prezzo: 8.0,
        },
      ],
      localData: {
        ricette: []
      },
      itemsDetail: [],
      selectedRowDetail: null,
      selectedRowEditIndex: null,
      selectedRowEditItem: null,
      prestazione: {
        quantita: 1,
        idListino: null,
        descrizionePrestazione: null,
        codicePrestazione: null,
        prezzo: 0,
        dataErogazione: new Date().getTime(),
        new: true,
      },
      // importo: 0,
      selectedCheckBoxs: [],
      presRegioniOptions: [],
      optionsCheckBoxGroup: [
        { text: "Anonimato", value: "anonimato" },
        { text: "STP", value: "stp" },
        { text: "ENI", value: "eni" },
        { text: "Conv", value: "conv" },
        { text: "TEAM", value: "team" },
        { text: "Cons", value: "cons" },
        { text: "Email", value: "emailBox" },
        { text: "Sconosciuto", value: "sconosciuto" },
      ],
      headersPrestazioni: [
        {
          label: "Quantità",
          key: "quantita",
          thStyle: "width: 10rem",
        },
        {
          label: "Listino",
          key: "listino",
        },
        {
          label: "Prestazione",
          key: "descrizionePrestazione",
        },
        {
          label: "Prezzo",
          key: "prezzo",
          thStyle: "width: 10rem",
        },
        {
          label: "Importo",
          key: "importo",
          thStyle: "width: 10rem",
        },
        {
          label: "Data Erogazione",
          key: "dataErogazione",
        },
        {
          label: "",
          key: "actions",
          tdClass: "sa-table-column-action-double",
        },
      ],
      headersImpegnative: [
        {
          label: "Tipologia",
          key: "tipologiaRicetta",
        },
        {
          label: "NRE",
          key: "nre",
        },
        {
          label: "Numero Prestazioni",
          key: "prestazioni",
        },
        {
          label: "",
          key: "actions",
          tdClass: "text-right",
        },
      ],
    };
  },
  mounted() {
    let me = this;
    me.isDematerializzata
      ? (me.localData.tipologiaRicetta = "DEMATERIALIZZATA")
      : null;
      me.selectedRowDetail=null,
      me.selectedRowEditIndex=null,
      me.selectedRowEditItem=null
      me.closeDetail();
      me.setJsonData();
      
    //me.onCaricaRicettaDematerializzata();
  },

  watch: {
  ricette:function () {
     this.setJsonData()
  },
    "prestazione.quantita": function (params) {
      let me = this;
      if (params >= 1 && me.prestazione.descrizionePrestazione != null) {
        let filter = me.prestazioniOptions.filter(
          (a) => a.value === me.prestazione.descrizionePrestazione
        );
        let prezzoPrestazione = filter[0].prezzo;
        me.prestazione.prezzo = prezzoPrestazione * params;
      }
    },

    "prestazione.descrizionePrestazione": function (params) {
      if (params) {
        let me = this;
        let filter = me.prestazioniOptions.filter((a) => a.value === params);
        let prezzoPrestazione = filter[0].prezzo;
        me.prestazione.prezzo = prezzoPrestazione * me.prestazione.quantita;
      }
    },
    "selectedRowEditItem.quantita": function (params) {
      let me = this;
      if (
        params >= 1 &&
        me.selectedRowEditItem.descrizionePrestazione != null
      ) {
        let filter = me.prestazioniOptions.filter(
          (a) => a.value === me.selectedRowEditItem.descrizionePrestazione
        );
        let prezzoPrestazione = filter[0].prezzo;
        me.selectedRowEditItem.prezzo = prezzoPrestazione * params;
      }
    },
    "selectedRowEditItem.descrizionePrestazione": function (params) {
      if (params) {
        let me = this;
        let filter = me.prestazioniOptions.filter((a) => a.value === params);
        let prezzoPrestazione = filter[0].prezzo;
        me.selectedRowEditItem.prezzo =
          prezzoPrestazione * me.selectedRowEditItem.quantita;
      }
    },
  },
  methods: {
    closeDetail(){
      let me = this;
      if(me.localData.ricette>=1){
        me.localData.ricette.forEach(element => {
          
          element;
          
        });
      }
    },
    setJsonData() {
      let me = this;
      me.localData.ricette = me.ricette;
    },
    onChangeTipologiaRicetta(tipologia) {
      this.$emit(
        "onIsTipologiaDematerilizzata",
        tipologia === "DEMATERIALIZZATA"
      );
    },
    onAggiungiImpegnativa(json) {
      let me = this;
      me.$emit("onAggiungiImpegnativa",json)
    },

    isBtnAggiungiPrestazioneDisabled() {
      if (this.prestazione.descrizionePrestazione == null) {
        return true;
      }
      if (this.prestazione.idListino == null) {
        return true;
      }
      return false;
    },
    isRowEdit(row) {
      let me = this;
      return row == null
        ? true
        : row.index == me.selectedRowEditIndex
        ? false
        : true;
    },
    emitChange() {
      let me = this;
      me.$emit('updateJsonRicette', me.localData.ricette);
    },
    onChangePrestazione(value) {
      let me = this;
      let prestazione = me.prestazioniOptions.find((p) => p.value === value);
      me.prestazione.codicePrestazione = prestazione.codice;
      me.prestazione.prezzo =
      prestazione.prezzo * Number(me.prestazione.quantita);
    },
    onModificaPrestazione(row) {
      let me = this;
      if (me.selectedRowEditIndex == null) {
        me.selectedRowEditIndex = row.index;
        me.selectedRowEditItem = JSON.parse(JSON.stringify(row.item));
      }
    },
    onAnnullaModifica() {
      let me = this;
      me.selectedRowEditIndex = null;
      me.selectedRowEditItem = null;
    },

    onClickStorico(row) {
      let me = this;
      if (me.selectedRowDetail) {
        if (me.selectedRowDetail.index === row.index) {
          if (row.detailsShowing) {
            row.toggleDetails();
            me.selectedRowDetail = null;
            me.itemsDetail = [];
            me.selectedRowEditIndex = null;
            me.selectedRowEditItem = null;
          }
          return;
        } else {
          me.selectedRowDetail.toggleDetails();
          me.selectedRowEditIndex = null;
          me.selectedRowEditItem = null;
        }
      }
      row.toggleDetails();
      me.selectedRowDetail = row;
      me.itemsDetail = [];
      me.loadPrestazioniImpegnativa(row.item);
    },
    loadPrestazioniImpegnativa(item) {
      let me = this;
      me.itemsDetail = [...item.prestazioni, me.prestazione];
    },
    onConfermaModificaPrestazione() {
      let me = this;      
      if (me.selectedRowEditIndex != null) {
        me.$set(
          me.itemsDetail,
          me.selectedRowEditIndex,
          JSON.parse(JSON.stringify(me.selectedRowEditItem))
        );
        me.selectedRowEditIndex = null;
        me.selectedRowEditItem = null;
      }
      let ricettaSelezionata = me.selectedRowDetail.item;
      let ricettaSelezionataMod = me.localData.ricette.filter((e)=>e.codiceBar1+e.codiceBar2 === ricettaSelezionata.codiceBar1+ricettaSelezionata.codiceBar2)
      ricettaSelezionataMod[0].prestazioni = me.itemsDetail.filter((e)=>e.new != true);
      me.emitChange();
    },
    onOpenModalImpegnativa() {
      let me = this;
      me.$refs.cmpAccettazioneImpegnativa.show();
    },
    onEliminaPrestazione(row) {
      let me = this;
      me.itemsDetail.splice(row.index, 1);

      let ricettaSelezionata = me.selectedRowDetail.item;
      let ricettaSelezionataMod = me.localData.ricette.filter((e)=>e.codiceBar1+e.codiceBar2 === ricettaSelezionata.codiceBar1+ricettaSelezionata.codiceBar2)
      ricettaSelezionataMod[0].prestazioni = me.itemsDetail.filter((e)=>e.new != true);

      me.emitChange();
    },
    onAggiungiPrestazione() {
      let me = this;
      let prestazione = JSON.parse(JSON.stringify(me.prestazione));
      delete prestazione.new;
      me.itemsDetail.pop();
      me.itemsDetail.push(prestazione);
      me.itemsDetail = [
        ...me.itemsDetail,
        {
          quantita: 1,
          idListino: null,
          prezzo: 0,
          descrizionePrestazione: null,
          codicePrestazione: null,
          dataErogazione: me.localData.dataInizioErogazione,
          new: true,
        },
      ];
      me.prestazione = {
        quantita: 1,
        idListino: null,
        prezzo: 0,
        descrizionePrestazione: null,
        codicePrestazione: null,
        dataErogazione: me.localData.dataInizioErogazione,
        new: true,
      };
      let ricetta = me.localData.ricette.filter(i=>i.codiceBar1 + i.codiceBar2 === me.selectedRowDetail.item.codiceBar1 + me.selectedRowDetail.item.codiceBar2) 
      ricetta[0].prestazioni.push(prestazione);
      me.emitChange();
    },
    getListinoText(value) {
      let me = this;
      let listino = me.listinoOptions.find(
        (listino) => listino.value === value
      );
      return listino ? listino.text : "";
    },
  },
};
</script>
